import { ROUTE_SIGN_UP_FLOW } from "apps/website/constants/routes";

const SCHEME = /^[a-z][a-z0-9+.-]*:/i;
const KATKIN_HOST = /^(?:https?:)?\/\/(?:www\.)?katkin\.com(?=[/?#]|$)/i;
// Host-ish prefix: label(.label)+ with optional port, then path/query/hash or end.
const BARE_HOST = /^[a-z0-9][a-z0-9-]*(?:\.[a-z0-9][a-z0-9-]*)+(?::\d+)?(?=[/?#]|$)/i;
const ASSET_EXTENSION = /\.(?:pdf|jpe?g|png|gif|webp|svg|mp4|webm|csv|zip|docx?|xlsx?)$/i;

// Mirrors CONTROL_ROOTS / TEST_ROOT / SIGNUP_FLOW_TEST_DISCOUNT_CODES in
// apps/website-functions/viewer-request/src/main.ts. That CloudFront Function is a
// standalone bundle with no imports, so the values can't be shared — keep both in step.
const LEGACY_SIGNUP_ROOTS = [ "/forms/fresh-new-user", "/forms/fresh-feast-trial" ] as const;
const LEGACY_SIGNUP_DISCOUNTS: Record<string, string> = {
  "/forms/fresh-feast-trial": "FEAST20",
};

const addMissingScheme = (href: string) => {
  if (SCHEME.test(href) || href.startsWith("/") || href.startsWith("#") || href.startsWith("?")) {
    return href;
  }
  const host = BARE_HOST.exec(href)?.[0];
  if (!host || ASSET_EXTENSION.test(host)) {
    return href;
  }
  return `https://${href}`;
};

const stripKatkinHost = (href: string) => {
  const stripped = href.replace(KATKIN_HOST, "");
  if (stripped === href) {
    return href;
  }
  return stripped.startsWith("/") ? stripped : `/${stripped}`;
};

export const normaliseHost = (href: string) => stripKatkinHost(addMissingScheme(href));

export const normaliseSignupPath = (href: string) => {
  const [ pathname, query ] = href.split("?");
  const legacyRoot = LEGACY_SIGNUP_ROOTS
    .find((root) => pathname === root || pathname.startsWith(`${root}/`));
  if (!legacyRoot) {
    return href;
  }

  // V1 step subpaths (e.g. /me/a-bit-about-you) have no v4 equivalent, so always
  // land on the v4 entry URL and keep only meaningful query params.
  // An empty discount_code would override the v4 flow's own default, so drop
  // valueless params rather than carrying them across.
  const params = (query ?? "").split("&").filter((param) => param.includes("=") && !param.endsWith("="));
  const defaultDiscount = LEGACY_SIGNUP_DISCOUNTS[legacyRoot];
  if (defaultDiscount && !params.some((param) => param.startsWith("discount_code="))) {
    params.push(`discount_code=${defaultDiscount}`);
  }

  return params.length ? `${ROUTE_SIGN_UP_FLOW}?${params.join("&")}` : ROUTE_SIGN_UP_FLOW;
};

export const normaliseHref = (href: string) => normaliseSignupPath(normaliseHost(href));
